function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
var _excluded = ["ariaLabel", "borderRadius", "children", "disableFloating", "display", "hideOverlay", "isOpen", "openOnFocus", "openOnHover", "openOnMount", "placement", "onOpen", "onClose", "onBeforeOpen", "onBeforeClose", "stopPropagation", "toggleIsOpenOnClick"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { borderRadius } from 'styled-system';
import { deprecatedColorValue } from 'pcln-design-system';
import PopoverContent from '../PopoverContent';
import usePopover from '../usePopover';
function Popover(_ref) {
  var _ref$ariaLabel = _ref.ariaLabel,
    ariaLabel = _ref$ariaLabel === void 0 ? 'Click to open popover with more information' : _ref$ariaLabel,
    _ref$borderRadius = _ref.borderRadius,
    borderRadius = _ref$borderRadius === void 0 ? 'xl' : _ref$borderRadius,
    children = _ref.children,
    _ref$disableFloating = _ref.disableFloating,
    disableFloating = _ref$disableFloating === void 0 ? false : _ref$disableFloating,
    _ref$display = _ref.display,
    display = _ref$display === void 0 ? 'inline-block' : _ref$display,
    hideOverlay = _ref.hideOverlay,
    isOpen = _ref.isOpen,
    openOnFocus = _ref.openOnFocus,
    openOnHover = _ref.openOnHover,
    openOnMount = _ref.openOnMount,
    placement = _ref.placement,
    onOpen = _ref.onOpen,
    onClose = _ref.onClose,
    onBeforeOpen = _ref.onBeforeOpen,
    onBeforeClose = _ref.onBeforeClose,
    _ref$stopPropagation = _ref.stopPropagation,
    stopPropagation = _ref$stopPropagation === void 0 ? true : _ref$stopPropagation,
    _ref$toggleIsOpenOnCl = _ref.toggleIsOpenOnClick,
    toggleIsOpenOnClick = _ref$toggleIsOpenOnCl === void 0 ? true : _ref$toggleIsOpenOnCl,
    props = _objectWithoutProperties(_ref, _excluded);
  var _usePopover = usePopover({
      openOnFocus: openOnFocus,
      openOnHover: openOnHover,
      openOnMount: openOnMount,
      placement: placement,
      onOpen: onOpen,
      onBeforeOpen: onBeforeOpen,
      onClose: onClose,
      onBeforeClose: onBeforeClose,
      disableFloating: disableFloating
    }),
    arrowRef = _usePopover.arrowRef,
    isPopoverOpen = _usePopover.isPopoverOpen,
    actualPlacement = _usePopover.placement,
    styles = _usePopover.styles,
    floating = _usePopover.floating,
    reference = _usePopover.reference,
    getFloatingProps = _usePopover.getFloatingProps,
    getReferenceProps = _usePopover.getReferenceProps,
    handleClose = _usePopover.handleClose,
    handleToggle = _usePopover.handleToggle;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children && /*#__PURE__*/React.cloneElement(children, _objectSpread({}, getReferenceProps({
    'aria-label': ariaLabel,
    type: 'button',
    ref: reference,
    onClick: !openOnHover && toggleIsOpenOnClick ? handleToggle : undefined
  }))), (isPopoverOpen || isOpen) && /*#__PURE__*/React.createElement(PopoverContent, getFloatingProps(_objectSpread(_objectSpread({}, props), {}, {
    arrowRef: arrowRef,
    borderRadius: borderRadius,
    display: display,
    hideOverlay: hideOverlay || openOnHover,
    placement: actualPlacement,
    popoverRef: floating,
    stopPropagation: stopPropagation,
    styles: styles,
    onCloseRequest: handleClose
  }))));
}
Popover.propTypes = _objectSpread(_objectSpread({}, borderRadius.propTypes), {}, {
  idx: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  // ID needs to be required for A11y purposes. We need to uniquely identify each popover on screen
  renderContent: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  p: PropTypes.number,
  color: deprecatedColorValue(),
  bg: deprecatedColorValue(),
  borderColor: PropTypes.string,
  placement: PropTypes.string,
  zIndex: PropTypes.number,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  overlayOpacity: PropTypes.number,
  trapFocus: PropTypes.bool,
  isOpen: PropTypes.bool,
  openOnHover: PropTypes.bool,
  openOnMount: PropTypes.bool,
  children: PropTypes.node,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  hideArrow: PropTypes.bool,
  hideOverlay: PropTypes.bool,
  display: PropTypes.string,
  toggleIsOpenOnClick: PropTypes.bool,
  stopPropagation: PropTypes.bool,
  onBeforeOpen: PropTypes.func,
  onBeforeClose: PropTypes.func,
  disableFloating: PropTypes.bool
});
export default Popover;